export default "\n.ql-align-center {\r\n  text-align: center;\n}\n.ql-align-right {\r\n  text-align: right;\n}\r\n"